import React from 'react'
import { 
    Button, 
    Row, 
    Input, 
} from 'antd'
import { firestore } from '../../../service/firebase'
import './Sponsor.scss'

const { TextArea } = Input


export default class Sponsor extends React.Component {

    state = {
        content: '',
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('Sponsor').doc('sponsor')
        .get()
        .then(snapshot => {

            let data = snapshot.data()
            console.log(data)
            
            if(data) {
                let { sponsor } = data
                this.setState({content: sponsor})    
            }
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    updateData() {
        let { content } = this.state
        let object = {
            sponsor: content
        }

        console.log("Data", object)

        let ref = firestore.collection('Sponsor').doc('sponsor')
        ref.set(object)
    }
    
    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/
   
    render() {

        return (
            <div className="sponsor">

                <div className="history">
                    <div className="title">Sponsors</div>

                    <div style={{flex: 1, marginTop: 32}}>

                        <Row className="input-row">
                            <div className="input-label">Content</div>
                            <TextArea autosize={{minRows: 3, maxRows: 18}} 
                                value={this.state.content} 
                                onChange={evt => this.handleChange('content', evt.target.value)} />
                        </Row>

                        <Row style={{textAlign: 'right', padding: 10}}>
                            <Button type="primary" icon="save" onClick={() => this.updateData()}>Update Sponsor</Button>
                        </Row>
                    </div>
                </div>

            </div>
        )
    }
}
